import React, { Component } from "react";
import ElectronicVerification from "@formatic/electronic-verification";
import AbnLookupComponent from "@formatic/abn-lookup";
import ProfileLookupComponent from "@formatic/profile-lookup";
import { Overrides } from "@formatic/sdk";

import OneRegistryLayout from "../../layouts/OneRegistry";
import Formatic from "../../components/Formatic";
import { ParamsFromURL } from "../../components/common";

import "@formatic/electronic-verification/dist/bundle.css";

let params;
const formProps = {
  apiServerUrl: "https://api.transformd.com",
  serverUrl: "https://api.transformd.com/graphql",
  subscriptionServerUrl: "wss://api.transformd.com/subscriptions",
  environment: "Live",
  channel: "master",
  apiKey: "4D6D46DAe538AD447Ae0ED513A27Ee2E4Dd2e1b996C97ba3D5fc11a29D5Fd805"
};

class FormRoute extends Component {
  constructor(props) {
    super(props);

    params = ParamsFromURL(props.location.search);
  }

  render() {
    return (
      <OneRegistryLayout>
        <div className="formatic-save-loading">
          <span>Saved</span>
        </div>
        <div className="page__example-fsf">
          <Formatic
            {...formProps}
            formId={586}
            config="default"
            submissionId={params.sessionId}
            theme="transformd"
            runReduxDevTools={process.env.NODE_ENV === "development"}
          >
            <Overrides.OverrideFieldContainer type="electronicVerification" component={ElectronicVerification} />
            <Overrides.OverrideFieldContainer component={AbnLookupComponent} type="abnLookup" />
            <Overrides.OverrideFieldContainer component={ProfileLookupComponent} type="profileLookup" />
          </Formatic>
        </div>
      </OneRegistryLayout>
    );
  }
}

export default FormRoute;
